import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
// import {Autosize} from 'ng-autosize';
import { NgModelOptionsModule } from '../../../../shared';
import { OptionComponent } from './option.component';

@NgModule({
  imports: [
  ],
  exports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,  NgModelOptionsModule,
    AutosizeModule,
    // Autosize,
  ],
  declarations: [OptionComponent],
})
export class OptionModule { }
